import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { type IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { RedoSvg } from './WpsRedosvg'

export const WpsRedoIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={RedoSvg} {...props} />
}
